export default __webpack_public_path__ + "static/media/duckduckgo_grey.9c7d8b73.svg";